import {
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { ClinicDetailState } from '../../../../shared/state/clinic-detail/clinic-detail.store';
import { Observable } from 'rxjs';
import { CompanyQuery } from '../../../../shared/state/company/company.query';
import { UserState } from '../../../../shared/state/user/user.store';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { AppointmentWizardComponent } from '../../../appointment-wizard/pages/appointment-wizard/appointment-wizard.component';
import { ModalController, Platform } from '@ionic/angular';
import { UserService } from '../../../../shared/state/user/user.service';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';
import { LocationService } from 'src/app/core/services/location/location.service';
import { SettingsQuery } from 'src/app/shared/state/settings/settings.query';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { UserAccountComponent } from '../../../user-account/pages/user-account/user-account.component';
import { ToastService } from '../../../../core/services/toast/toast.service';
import { LibraryService } from '../../../../core/services/library/library.service';
import { Clipboard } from '@capacitor/clipboard';
import { AppLauncher } from '@capacitor/app-launcher';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-clinic-view-body',
    templateUrl: './clinic-view-body.component.html',
    styleUrls: ['./clinic-view-body.component.scss'],
})

/** No se por qué me da error el launnch navigator del constructor */
export class ClinicViewBodyComponent implements OnInit {
    @Input() clinic: ClinicDetailState;
    @Input() isBrowser: boolean;

    companyFwaAppDisableTemp$: Observable<boolean>;
    user$: Observable<UserState>;
    isGeneric$: Observable<boolean>;
    isUserAccountATab: boolean;
    isEnabledUserAccount: boolean;

    public mapsSrc: SafeUrl = '';
    constructor(
        private companyQuery: CompanyQuery,
        private userQuery: UserQuery,
        private modalController: ModalController,
        private userService: UserService,
        private callNumber: CallNumber,
        private clinicDetailQuery: ClinicDetailQuery,
        private locationService: LocationService,
        private settingsQuery: SettingsQuery,
        private platform: Platform,
        private emailComposer: EmailComposer,
        private loadingService: LoadingService,
        private toastService: ToastService,
        private libraryService: LibraryService,
        private sanitizer: DomSanitizer
    ) {
        // @ts-ignore
        window.initMap = () => {
            const position = { lat: this.latitude, lng: this.longitude };
            // @ts-ignore
            const map = new google.maps.Map(document.getElementById('map'), {
                center: position,
                disableDefaultUI: true,
                zoom: 18,
                draggable: false
            });

            // @ts-ignore
            const marker = new google.maps.Marker({
                position,
                map,
            });
        };
    }

    get longitude(): number {
        return parseFloat(this.clinic.longitude);
    }

    get latitude(): number {
        return parseFloat(this.clinic.latitude);
    }

    get hasMap(): boolean {
        return (
            this.clinic.id !== '' &&
            this.clinic.latitude !== '0' &&
            this.clinic.longitude !== '0' &&
            environment.googleMapsApiKey !== ''
        );
    }

    ngOnInit(): void {
        this.companyFwaAppDisableTemp$ = this.companyQuery.select(
            'fwaAppDisableTemp'
        );
        this.user$ = this.userQuery.select();
        this.isGeneric$ = this.settingsQuery.selectIsGeneric();
        this.settingsQuery.selectIsUserAccountATab().subscribe((value) => {
            this.isUserAccountATab = value;
        });
        this.settingsQuery.selectIsEnabledUserAccount().subscribe((value) => {
            this.isEnabledUserAccount = value;
        });

        this.initScriptMap();
    }

    async presentModalAppointmentWizard() {
        //TODO: Mejoramos parpadeo, comentando las lineas siguientes, ya que justo seguido hay otra llamada, entonces para hacer la 
        //llamada del check, no mostramos spinner.
        //this.loadingService.updateShowSpinner(true);
        await this.checkUserCanMakesAppointment();
        //this.loadingService.updateShowSpinner(false);

        const modal = await this.modalController.create({
            component: AppointmentWizardComponent,
            cssClass: this.settingsQuery.browser ? 'modal-flowwwer modal-browser' : 'modal-flowwwer',
        });
        return await modal.present();
    }

    async presentModalUserAccount() {
        const modal = await this.modalController.create({
            component: UserAccountComponent,
            cssClass: this.settingsQuery.browser ? 'modal-flowwwer modal-browser' : 'modal-flowwwer',
        });
        return await modal.present();
    }

    /** Comprueba si el usuario puede pedir citas antes de abrir el modal de cita */
    async checkUserCanMakesAppointment() {
        await this.userService.checkUserCanMakesAppointment();
    }

    async openAppMaps() {
        const { latitude, longitude, comercialName } = this.clinicDetailQuery;

        if (Capacitor.isNativePlatform()) {
            const url = this.platform.is('android')
                ? `geo:0,0?q=${latitude},${longitude}`
                : `http://maps.apple.com/?ll=${latitude},${longitude}&q=${encodeURIComponent(
                      comercialName
                  )}`;

            await AppLauncher.openUrl({ url });
        } else {
            const urlMaps = `https://maps.google.com/?q=${latitude},${longitude}`;
            window.open(urlMaps);
        }
    }

    callClinic() {
        if (Capacitor.isNativePlatform()) {
            this.callNumber
                .callNumber(this.clinicDetailQuery.phone, true)
                .then((res) => console.log('Launched dialer!', res))
                .catch((err) => console.log('Error launching dialer', err));
        } else {
            const win = window.open('tel:' + this.clinicDetailQuery.phone);
            win.focus();
        }
    }

    async openUrl(link) {
        if (Capacitor.isNativePlatform()) {
            await Browser.open({ url: link });
        } else {
            const win = window.open(link, '_blank');
            win.focus();
        }
    }

    /* send email */
    async sendEmail(mailto: string) {
        try {
            await Clipboard.write({
                string: mailto,
            });
            await this.toastService.presentInfoToast(
                this.libraryService.getLabel('app_mail_copy_success')
            );
        } catch (e) {
            await this.toastService.presentErrorToast(
                this.libraryService.getLabel('app_mail_copy_error')
            );
        }

        if (Capacitor.isNativePlatform()) {
            const email = {
                to: mailto,
            };
            this.emailComposer.open(email);
        } else {
            window.location.href = 'mailto:' + mailto;
        }
    }

    initScriptMap(): void {
        this.mapsSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=${this.latitude},${this.longitude}&zoom=18`);
    }
}
